/*
 * @Author: changcheng
 * @LastEditTime: 2022-09-16 10:36:54
 */
import { Form, Divider } from "antd";
import { BarChart } from "../components/barChart";
import {
  getProvinceHospitalDataManage,
  getProvinceUserDataManage,
  getProvinceTrainDataManage,
} from "@root/common/service";
import { useEffect, useState } from "react";
import SubjectSelect from "@root/components/selectBox/subjectSelect";
export interface EchartHostitalDataProps {
  cityCode: string;
  cityName: string;
  recipientHospitalCount: number;
  supportHospitalCount: number;
}
export interface EchartUserDataProps {
  learnUserCount: number;
  cityCode: string;
  cityName: string;
  userCount: number;
}
export interface EchartTrainDataProps {
  learnRatio: number;
  learnRatioText: string;
  learnUserCount: number;
  cityCode: string;
  cityName: string;
  userCount: number;
}
const China = () => {
  const [hospitalChartData, setHospitalChartData] = useState<[]>([]);
  const [learningChartData, setLearningChartData] = useState<[]>([]);
  const [percentOfPassData, setPercentOfPassData] = useState<[]>([]);

  async function getOverAllOverViewData(subject?: number | undefined) {
    const { data: hospitalData } = await getProvinceHospitalDataManage({ subjectId: subject });
    const { data: userData } = await getProvinceUserDataManage({ subjectId: subject });
    const { data: trainData } = await getProvinceTrainDataManage({ subjectId: subject });

    const initHospitalData: [] = hospitalData.map((item: EchartHostitalDataProps) => {
      return [
        item.cityName,
        item.recipientHospitalCount,
        item.supportHospitalCount,
      ];
    })
    const initLearningData: [] = userData.map((item: EchartUserDataProps) => {
      return [
        item.cityName,
        item.userCount,
        item.learnUserCount,
      ];
    })
    const initPercentData: [] = trainData.map((item: EchartTrainDataProps) => {
      return [
        item.cityName,
        item.learnRatio,
      ];
    })

    
    setHospitalChartData(initHospitalData);
    setLearningChartData(initLearningData);
    setPercentOfPassData(initPercentData);
  }
  useEffect(() => {
    getOverAllOverViewData();
  }, []);
  
  const onSelectChangeHandle = (value: any) => {
    if (value === 'all') {
      value = undefined;
    }

    getOverAllOverViewData(value)
  }
  return (
    <div>
      <Form>
        <SubjectSelect
          label={false}
          showAll={true}
          styles={{ width: 160 }}
          onSelect={(value) => { onSelectChangeHandle(value) }}
        />
      </Form>
      <Divider />
      <BarChart
        id="hospital" 
        subtitle="单位：家"
        dimensions={["受援医院数", "支援医院数"]}
        sources={hospitalChartData} 
        hideExport={true}
      />
      <BarChart 
        id="learning"
        subtitle="单位：人"
        dimensions={["注册人数", "学习人数"]}
        sources={learningChartData} 
        hideExport={true}
      />
      <BarChart 
        id="percent"
        subtitle="单位：%"
        dimensions={["培训率"]}
        sources={percentOfPassData} 
        hideExport={true}
      />
    </div>
  );
};

export default China;
